const userGuideLink =
  "https://app.lexicallabs.com/Lexical%20Labs%20User%20Guide.pdf";

export default userGuideLink;
